import {IUserDashboardSetting, IUserDashboardSettingState} from "../types/redux_types";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export const initialState: IUserDashboardSettingState = {
    dataArray: []
}


export const userDashboardSettingsSlice = createSlice({
    name: 'userDashboardSettingsState',
    initialState,
    reducers: {
        updateUserDashboardSettingsArray (state, action: PayloadAction<IUserDashboardSetting[]>){
            state.dataArray = action.payload;
        }
    }
})

export default userDashboardSettingsSlice.reducer;